// extracted by mini-css-extract-plugin
export var card = "_mm-0";
export var content = "_mm-2";
export var details = "_mm-3";
export var icon = "_mm-1";
export var iconBlue = "_mm-5";
export var iconBrand = "_mm-4";
export var iconGrayBlue = "_mm-6";
export var iconGreen = "_mm-7";
export var iconIndigo = "_mm-8";
export var iconOrange = "_mm-9";
export var iconPurple = "_mm-a";
export var iconRed = "_mm-b";
export var iconWarning = "_mm-c";